import { faEye, faPencil, faSend, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Row } from "react-bootstrap";
import { VisitorType } from "src/app/enums/Index";
import { GetPropertiesFromEnum } from "src/app/helpers/GetPropertiesFromEnum";
import { User, Visit, Visitor } from "src/app/interfaces/Index";
import { FileService, UserService, VisitService, VisitorService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";

type Props = {};
type State = {
	dropdownUsers: any;
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	visitorTypes: any;
	masterItems: Visitor[];
	items: Visitor[];
	selectedItem: Visitor;
	showDeleteModal: boolean;
	showItemInfoModal: boolean;
	showSendNotificationModal: boolean;
	showVisitsModal: boolean;
	statusChangeReason: string;
	submitted: boolean;
	users: User[];
	visits: Visit[];
};

export class AdminVisitors extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Visitor";
	itemNamePlural: string = "Visitors";

	constructor(props: Props) {
		super(props);
		this.state = {dropdownUsers: [], isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", visitorTypes: GetPropertiesFromEnum(VisitorType), masterItems: [], selectedItem: new Visitor(), items: [], showDeleteModal: false, showItemInfoModal: false, showSendNotificationModal: false, showVisitsModal: false, statusChangeReason: "", submitted: false, users: [], visits: []};
	}

	componentDidMount() {
		this.getItems();
		this.getStaff();
	}

	async deleteItemConfirm() {
		this.setState({isLoading: true});
			const res = await VisitorService.deleteSingleById(this.state.selectedItem.id);

			if (res.ok) {
				this.setState({isLoading: false, showDeleteModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been deleted", life: 5000, severity: "success", summary: this.itemName + " deleted!"});
				this.getItems();
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
	}

	dropdownChange(e: any, name: string) {
		const val = e.value === undefined ? null : e.value;
		let selectedItem = new Visitor({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	itemInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new Visitor(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
		);
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await VisitorService.getAll();

		if (res.ok) {
			const response = await res.json();
			this.setState({isLoading: false, items: response, masterItems:response});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	async getStaff() {
		this.setState({isLoading: true});
		const res = await UserService.staff();

		if (res.ok) {
			const response = await res.json();
			const dropdownUsers = response.map((user: User): any => ({
				id: user.id,
				fullName: `${user.firstName} ${user.lastName}`
			}));

			this.setState({isLoading: false, users: response, dropdownUsers: dropdownUsers});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Visitor({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							<DataTable loading={this.state.isLoading} ref={(el) => this.dt = el} scrollable scrollHeight="flex" style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items} sortField="name" sortOrder={1}>
							<Column field="name" header="Name" sortable></Column>
							<Column field="companyName" header="Company" sortable></Column>
							<Column field="visitorType" header="Type" sortable body={(rowData: any) => this.renderVisitorType(rowData.visitorType)}></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.buttons.edit, borderColor: colours.buttons.edit, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Edit">
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showSendNotificationModal: true})} style={{backgroundColor: colours.buttons.send, borderColor: colours.buttons.send, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Send Access Code">
											<FontAwesomeIcon icon={faSend} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.showVisits(rowData)} style={{backgroundColor: colours.buttons.view, borderColor: colours.buttons.view, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="View Visits">
											<FontAwesomeIcon icon={faEye} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.buttons.delete, borderColor: colours.buttons.delete, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Remove">
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="visitorType">Visitor Type <span className="required">*</span></label>
											<Dropdown id="visitorType" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, visitorType: e.value}})} options={this.state.visitorTypes} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.visitorType}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="name">Name <span className="required">*</span></label>
											<InputText id="name" value={this.state.selectedItem.name} onChange={(e) => this.inputChange(e, "name")}/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="emailAddress">Email Address <span className="required">*</span></label>
											<InputText id="emailAddress" value={this.state.selectedItem.emailAddress} onChange={(e) => this.inputChange(e, "emailAddress")}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="telephoneNumber">Telephone Number <span className="required">*</span></label>
											<InputText id="telephoneNumber" value={this.state.selectedItem.telephoneNumber} onChange={(e) => this.inputChange(e, "telephoneNumber")}/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="companyName">Company Name</label>
											<InputText id="companyName" value={this.state.selectedItem.companyName} onChange={(e) => this.inputChange(e, "companyName")}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="vehicleRegistration">Vehicle Registration</label>
											<InputText id="vehicleRegistration" value={this.state.selectedItem.vehicleRegistration} onChange={(e) => this.inputChange(e, "vehicleRegistration")}/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="photoUrl" style={{ width: "100%" }}>Photo</label>
											<img id="photoUrl" src={this.state.selectedItem.photoUrl} style={{ height: 50, marginBottom: 10, marginTop: 10 }}></img>
										</div>
										<FileUpload accept="image/*" auto customUpload name="photoUrl" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "photoUrl")} mode="basic"></FileUpload>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="accessCode">Access Code</label>
											<InputText id="accessCode" value={this.state.selectedItem.accessCode} readOnly={true}/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="userId">Here to See</label>
											<Dropdown id="userId" onChange={(e:any) => this.dropdownChange(e, "userId")} options={this.state.dropdownUsers} optionLabel="fullName" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.userId} showClear />
										</div>
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" footer={() => this.renderDeleteItemFooter()} header={"Delete " + this.itemName} modal onHide={() => this.setState({ showDeleteModal: false })} style={{ width: "75%" }} visible={this.state.showDeleteModal}>
								<Row>
									<Col>
										Are you sure you wish to delete the selected item?
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" footer={() => this.renderSendNotificationFooter()} header={"Send Access Code Notification"} modal onHide={() => this.setState({ showSendNotificationModal: false })} style={{ width: "75%" }} visible={this.state.showSendNotificationModal}>
								<Row>
									<Col>
										Send an Access Code notification to {this.state.selectedItem.name}
									</Col>
								</Row>
								<Row>
									<Col>
										Email Address: {this.state.selectedItem.emailAddress}
									</Col>
								</Row>
								<Row>
									<Col>
										Phone Number: {this.state.selectedItem.telephoneNumber}
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" header={"Visits by " + this.state.selectedItem.name} modal onHide={() => this.setState({ showVisitsModal: false })} style={{ width: "75%" }} visible={this.state.showVisitsModal}>
								<Row>
									<DataTable loading={this.state.isLoading} ref={(el) => this.dt = el} scrollable scrollHeight="flex" style={{height: "calc(100vh - 17.5rem)"}} value={this.state.visits} sortField="startDate" sortOrder={1}>
										<Column field="startDate" header="Start" sortable body={(rowData: any) => this.renderDateTime(rowData.startDate)}></Column>
										<Column field="endDate" header="End" sortable body={(rowData: any) => this.renderDateTime(rowData.endDate)}></Column>
										<Column field="reasonForVisit" header="Reason" sortable></Column>
									</DataTable>
								</Row>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderDateTime(e?: Date) {
		if (e === undefined || e === null) {
			return "";
		}

		const date = new Date(e);
		return date.toLocaleString('en-GB');
	}

	renderDeleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteItemConfirm()}></Button>
			</>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.buttons.add, borderColor: colours.buttons.add, marginRight: 10}} onClick={() => this.setState({selectedItem: new Visitor(), showItemInfoModal: true})}></Button>
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-download" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	renderSendNotificationFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-envelope" label="Send by Email" onClick={() => this.sendNotificationByEmail()}></Button>
				<Button className="p-button-text" icon="pi pi-phone" label="Send by SMS" onClick={() => this.sendNotificationBySMS()}></Button>
			</>
		);
	}

	renderVisitorType(e: VisitorType) {
		const visitorType = this.state.visitorTypes.filter((f: { id: any, name: string; }) => f.id === e)[0];
		return visitorType === undefined ? "???" : visitorType.name;
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await VisitorService.createSingle(this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		} else { // Save existing
			const res = await VisitorService.updateSingleById(this.state.selectedItem.id, this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		}
		await this.getItems();
	}

	async sendNotificationByEmail() {
		this.setState({isLoading: true});
			const res = await VisitorService.sendEmailNotification(this.state.selectedItem.id);

			if (res.ok) {
				this.setState({isLoading: false});
				this.toast.show({closable: false, detail: "Email Notification has been sent", life: 5000, severity: "success", summary: "Access Code Sent"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
	}

	async sendNotificationBySMS() {
		this.setState({isLoading: true});
			const res = await VisitorService.sendSMSNotification(this.state.selectedItem.id);

			if (res.ok) {
				this.setState({isLoading: false});
				this.toast.show({closable: false, detail: "SMS Notification has been sent", life: 5000, severity: "success", summary: "Access Code Sent"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
	}

	async showVisits(rowData: any) {

		this.setState({isLoading: true});
		const res = await VisitService.forVisitor(rowData.id);

		if (res.ok) {
			const response = await res.json();
			this.setState({isLoading: false, selectedItem: rowData, showVisitsModal: true, visits: response});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await(await FileService.upload(uploadData)).json();
		let selectedItem = {...this.state.selectedItem};
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({selectedItem});
	}
}